/**
 * @fileoverview Pure date/time formatters for the Chat page.
 * @module pages/chat/chatFormatters
 */
import { MINUTES_PER_HOUR, NOON_HOUR } from "../../utils/chatUiConstants.js";

/** Formats YYYY-MM-DD into a localized long date string. */
export const formatLongDateLocalized = (ymd, lang) => {
  if (!ymd) {
    return "";
  }
  try {
    const [y, m, d] = ymd.split("-").map((v) => parseInt(v, 10));
    if (!y || !m || !d) {
      return ymd;
    }
    const date = new Date(y, m - 1, d);
    const formatted = date.toLocaleDateString(lang || "es", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    if ((lang || "es").startsWith("es")) {
      return formatted.replaceAll(",", "").toLowerCase();
    }
    return formatted;
  } catch {
    return ymd;
  }
};

/** Formats an ISO timestamp into HH:MM AM/PM. */
export const formatTimeWithSuffix = (iso) => {
  if (!iso) {
    return "";
  }
  try {
    const date = new Date(iso);
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const hh = String(hours).padStart(2, "0");
    const suffix = hours < NOON_HOUR ? "AM" : "PM";
    return `${hh}:${minutes} ${suffix}`;
  } catch {
    return iso;
  }
};

/** Converts HH:MM duration string to total minutes. */
export const durationToMinutes = (hhmm) => {
  if (!hhmm) {
    return "";
  }
  const [hh, mm] = hhmm.split(":").map((x) => parseInt(x || 0, 10));
  const total =
    (isNaN(hh) ? 0 : hh) * MINUTES_PER_HOUR + (isNaN(mm) ? 0 : mm);
  return total.toString();
};
